import { render, staticRenderFns } from "./Wait.vue?vue&type=template&id=60aca5d1&scoped=true"
import script from "./Wait.vue?vue&type=script&lang=js"
export * from "./Wait.vue?vue&type=script&lang=js"
import style0 from "./Wait.vue?vue&type=style&index=0&id=60aca5d1&prod&lang=scss&scoped=true"
import style1 from "./Wait.vue?vue&type=style&index=1&id=60aca5d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aca5d1",
  null
  
)

export default component.exports